import { render } from "./ProductDetailHeader.vue?vue&type=template&id=d0d955f6&scoped=true"
import script from "./ProductDetailHeader.vue?vue&type=script&lang=js"
export * from "./ProductDetailHeader.vue?vue&type=script&lang=js"

import "./ProductDetailHeader.vue?vue&type=style&index=0&id=d0d955f6&scoped=true&lang=css"

import exportComponent from "/Users/learnbody/Documents/VSWorkspaces/learnbody-market-v1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0d955f6"]])

export default __exports__